import { render, staticRenderFns } from "./WeekHeader.vue?vue&type=template&id=4bd6099d&scoped=true"
import script from "./WeekHeader.vue?vue&type=script&lang=js"
export * from "./WeekHeader.vue?vue&type=script&lang=js"
import style0 from "./WeekHeader.vue?vue&type=style&index=0&id=4bd6099d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6099d",
  null
  
)

export default component.exports